module.exports = "<app-resolve promise=\"$ctrl.promise\">\r\n  <!--<div class=\"margin-md padding-md\" ng-if=\"$ctrl.data.length\">\r\n    <p class=\"text-bold\">\r\n      Seleccione  <i class=\"fa fw fa-lg fa-cog\"></i>  para configurar el pago.\r\n    </p>\r\n  </div>-->\r\n  <p class=\"margin-md text-align-center\"\r\n      ng-if=\"!$ctrl.data.length\">\r\n    No hay pagos pendientes\r\n  </p>\r\n  <viaticos-pagos-lista results=\"$ctrl.results\"></viaticos-pagos-lista>\r\n</app-resolve>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/pagos/pendientes/template.html
// module id = 3272
// module chunks = 0